<!-- eslint-disable -->
<template>

    <!--TODO: исправить ошибку при удаленном товаре-->
    <!--TODO: исправить при добавлении товара без вариантов -->

    <div class="row">
        <!--begin::Aside-->
        <div class="col-md-4" id="kt_profile_aside">
            <!--begin::List Widget 17-->
            <div class="card card-custom gutter-b">

                <div class="card-body">
                    <h3 class="font-weight-bold font-size-h4 text-dark-75 mb-3">Клиент</h3>
                    <div class="text-muted font-weight-bold font-size-sm mb-6">Общая информация о клиенте</div>
                    <div v-if="order.note" class="font-size-sm mb-6">
                        <span class="text-dark-50 flex-root font-weight-bold">Комментарий к заказу:<br></span>
                        {{order.note}}
                    </div>

                    <div v-if="order.client" class="d-flex mb-3">
                        <span class="text-dark-50 flex-root font-weight-bold">Аккаунт:</span>
                        <span class="text-dark flex-root font-weight-bold">
                            <router-link :to="{ name: 'Client', params: {id: order.client.id}}">
                                {{ order.client.name }}
                            </router-link></span>
                    </div>

                    <div class="d-flex mb-3">
                        <span class="text-dark-50 flex-root font-weight-bold">Имя:</span>
                        <span class="text-dark flex-root font-weight-bold">{{ order.name + ' ' + order.surname}}</span>
                    </div>

                    <div v-if="order.client" class="d-flex mb-3">
                        <span class="text-dark-50 flex-root font-weight-bold">Клиент:</span>
                        <span v-if="order.client.client_type === 'natural_person'" class="text-dark flex-root font-weight-bold">Физическое лицо</span>
                        <span v-if="order.client.client_type === 'entity'" class="text-dark flex-root font-weight-bold">Юридическое лицо</span>
                    </div>

                    <div v-if="order.client && order.client.name_of_company" class="d-flex mb-3">
                        <span class="text-dark-50 flex-root font-weight-bold">Название организации:</span>
                        <span class="text-dark flex-root font-weight-bold">{{order.client.name_of_company}}</span>
                    </div>

                    <div v-if="order.client && order.client.inn" class="d-flex mb-3">
                        <span class="text-dark-50 flex-root font-weight-bold">ИНН:</span>
                        <span class="text-dark flex-root font-weight-bold">{{order.client.inn}}</span>
                    </div>

                    <div v-if="order.client && order.client.kpp" class="d-flex mb-3">
                        <span class="text-dark-50 flex-root font-weight-bold">КПП:</span>
                        <span class="text-dark flex-root font-weight-bold">{{order.client.kpp}}</span>
                    </div>

                    <div class="d-flex mb-3">
                        <span class="text-dark-50 flex-root font-weight-bold">Email:</span>
                        <span class="text-dark flex-root font-weight-bold">{{order.email}}</span>
                    </div>
                    <div class="d-flex mb-3">
                        <span class="text-dark-50 flex-root font-weight-bold">Телефон:</span>
                        <span class="text-dark flex-root font-weight-bold">{{order.phone}}</span>
                    </div>
                    <div class="d-flex mb-3">
                        <span class="text-dark-50 flex-root font-weight-bold">Город:</span>
                        <span class="text-dark flex-root font-weight-bold">{{order.city}}</span>
                    </div>
                    <div class="d-flex mb-3">
                        <span class="text-dark-50 flex-root font-weight-bold">Вид платежа:</span>
                        <span class="text-dark flex-root font-weight-bold">{{order.payment.type}}</span>
                    </div>
                    <div class="d-flex">
                        <span class="text-dark-50 flex-root font-weight-bold">Способ доставки</span>
                        <span class="text-dark flex-root font-weight-bold">{{order.delivery_type.name}}</span>
                    </div>

                    <div v-if="order.client && order.client.legal_address" class="font-size-sm mt-3">
                        <span class="text-dark-50 flex-root font-weight-bold">Юридический адрес:<br></span>
                        <span class="text-dark flex-root font-weight-bold">{{order.client.legal_address}}</span>
                    </div>

                    <div v-if="order.client && order.client.mailing_address" class="font-size-sm mt-3">
                        <span class="text-dark-50 flex-root font-weight-bold">Почтовый адрес:<br></span>
                        <span class="text-dark flex-root font-weight-bold">{{order.client.mailing_address}}</span>
                    </div>

                    <div v-if="order.address" class="font-size-sm mt-3">
                        <span class="text-dark-50 flex-root font-weight-bold">Адрес доставки:<br></span>
                        <span class="text-dark flex-root font-weight-bold">{{order.address}}</span>
                    </div>
                    <!--end::Info-->



                </div>

            </div>
            <!--end::List Widget 17-->

            <!--begin::List Widget 21-->
            <div class="card card-custom gutter-b">
                <!--begin::Header-->
                <div class="card-header border-0 pt-5">
                    <h3 class="card-title align-items-start flex-column mb-5">
                        <span class="card-label font-weight-bolder text-dark mb-1">Управление заказом</span>
                    </h3>
                </div>
                <!--end::Header-->

                <!--begin::Body-->
                <div class="card-body pt-0">

                    <b-form-group
                                  description="Выберите статус заказа и нажмите *Сохранить"
                                  label="Статус заказа:"
                    >
                        <b-form-select v-model="order.order_status_id" >
                            <template v-for="(status, i) in statuses" >
                                <option v-bind:key="i" :value="status.id">{{status.name}}</option>
                            </template>
                        </b-form-select>

                        <b-button @click="updateStatus" ref="update-status" size="sm" variant="primary" class="text-center mt-2 btn-block">
                            Сохранить статус
                        </b-button>

                    </b-form-group>

                    <b-link @click="editOrder" class="btn btn-light-success font-weight-bold py-3 px-6 mt-5 text-center btn-block">
                        Редактировать заказ
                    </b-link>

                    <b-link v-if="$can('deletion')" @click="showDeleteOrder" class="btn btn-light-danger font-weight-bold py-3 px-6 mb-2 text-center btn-block">
                        Удалить заказ
                    </b-link>

                </div>
                <!--end::Body-->
            </div>
            <!--end::List Widget 21-->    </div>
        <!--end::Aside-->

        <!--begin::Layout-->
        <div class="col-md-8">
            <!--begin::Card-->
            <div class="card card-custom gutter-b">
                <div class="card-body p-0">
                    <!-- begin: Invoice-->
                    <!-- begin: Invoice header-->
                    <div class="row justify-content-center py-8 px-8 py-md-10 px-md-0">
                        <div class="col-md-10">
                            <div class="d-flex justify-content-between pb-10 pb-md-5 flex-column flex-md-row">
                                <h2 class="font-weight-boldest mb-10">ДЕТАЛИ ЗАКАЗА</h2>
                            </div>
                            <div class="border-bottom w-100"></div>
                            <div class="d-flex justify-content-between pt-6">
                                <div class="d-flex flex-column flex-root">
                                    <span class="font-weight-bolder mb-2">ДАТА ЗАКАЗА</span>
                                    <span class="opacity-70">{{moment(order.created_at).format('lll')}}</span>
                                </div>
                                <div class="d-flex flex-column flex-root">
                                    <span class="font-weight-bolder mb-2">НОМЕР ЗАКАЗА</span>
                                    <span class="opacity-70">{{order.id}}</span>
                                </div>
                                <div class="d-flex flex-column flex-root">
                                    <span class="font-weight-bolder mb-2 text-right">АДРЕС ДОСТАВКИ</span>
                                    <span class="opacity-70 text-right">{{order.name + ' ' + order.surname}}, {{order.city}}.<br />{{order.address}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end: Invoice header-->

                    <!-- begin: Invoice body-->
                    <div class="row justify-content-center py-8 px-8 py-md-10 px-md-0">
                        <div class="col-md-10">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th class="pl-0 font-weight-bold text-muted  text-uppercase">Товары</th>
                                        <th class="text-right font-weight-bold text-muted text-uppercase">Доставка</th>
                                        <th class="text-right font-weight-bold text-muted text-uppercase">Артикул</th>
                                        <th class="text-right font-weight-bold text-muted text-uppercase">Кол-во</th>
                                        <th class="text-right font-weight-bold text-muted text-uppercase">Цена за еденицу</th>
                                        <th class="text-right pr-0 font-weight-bold text-muted text-uppercase">Сумма</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template v-for="(item, i) in order.ordered_items">
                                        <tr  v-bind:key="i" >
                                            <td style="max-width: 200px" class="border-0 pl-0 pt-7 ">

                                                <div class="d-flex align-items-center">

                                                    <div class="symbol symbol-40 flex-shrink-0 mr-4 bg-light">
                                                        <div class="symbol-label" :style="{ backgroundImage: 'url(' + $urlBackEnd(item.image) + ')' }"></div>
                                                    </div>
                                                    <span class="text-dark flex-root font-weight-bold"><router-link :to="{ name: 'FormProduct', params: {action: 'edit', id: item.product_id}}">{{item.title}}</router-link></span>
                                                </div>


                                                <div class="mt-2">
                                                    <span class="font-weight-boldest">Еденица измерения: </span>
                                                    {{item.unit_of_measure}}
                                                </div>

                                                <div class="mt-2">
                                                    <span class="font-weight-boldest">Вес: </span>
                                                    {{item.weight}}
                                                </div>

                                                <div class="mt-2">
                                                    <span class="font-weight-boldest">Объём: </span>
                                                    {{item.volume}}
                                                </div>

                                                <div v-if="item.properties && item.properties.length > 0">
                                                    <div class="mt-2" v-for="property in item.properties">
                                                        <span class="font-weight-boldest">{{property.name}}:</span> {{ property.value.name}} <br>
                                                    </div>
                                                </div>

                                            </td>

                                            <td class="text-right pt-7 align-middle">
                                                <div v-if="item.city" class="font-weight-boldest">{{item.city.name}}</div>
                                                <div v-else class="font-weight-boldest">Не выбран город</div>
                                                <div v-if="item.method && item.city" class="font-weight-boldest">{{item.method.name}}</div>
                                            </td>

                                            <td class="text-right pt-7 align-middle">
                                                <span class="opacity-70">{{item.sku}}</span>
                                            </td>
                                            <td class="text-right pt-7 align-middle">{{item.qty}}</td>
                                            <td class="text-right pt-7 align-middle">{{numberWithSpaces(item.price)}} <i class="text-dark icon-nm fas fa-ruble-sign"></i></td>
                                            <td class="text-primary pr-0 pt-7 text-right align-middle">{{numberWithSpaces(total(item.price, item.qty))}} <i class="text-primary icon-nm fas fa-ruble-sign"></i></td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- end: Invoice body-->

                    <!-- begin: Invoice footer-->
                    <div class="row justify-content-center bg-gray-100 py-8 px-8 py-md-10 px-md-0 mx-0">
                        <div class="col-md-10">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th class="font-weight-bold text-muted  text-uppercase">Вид платежа</th>
                                        <th class="font-weight-bold text-muted  text-uppercase">Статус оплаты</th>
<!--                                        <th class="font-weight-bold text-muted  text-uppercase">Дата оплаты</th>-->
                                        <th class="font-weight-bold text-muted  text-uppercase text-right">Всего к оплате</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr class="font-weight-bolder">
                                        <td>{{order.payment.type}}</td>
                                        <td>{{order.payment.status}}</td>
<!--                                        <td v-if="order.payment.status == 'Выполнен'">{{moment(order.payment.updated_at).format('lll')}}</td>-->
<!--                                        <td v-else > - </td>-->
                                        <td class="text-primary font-size-h3 font-weight-boldest text-right">{{numberWithSpaces(order.payment.sum)}} <i class="text-primary fas fa-ruble-sign"></i></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- end: Invoice footer-->

                    <!-- begin: Invoice action-->
                    <div class="row justify-content-center py-8 px-8 py-md-10 px-md-0">
                        <div class="col-md-10">
                            <div class="d-flex justify-content-between">

                                <button type="button" class="btn btn-primary font-weight-bold" onclick="window.print();">Распечатать заказ</button>
                            </div>
                        </div>
                    </div>
                    <!-- end: Invoice action-->

                    <!-- end: Invoice-->
                </div>
            </div>
            <!--end::Card-->
        </div>
        <!--end::Layout-->

        <b-modal ref="edit-order" size="xl" centered hide-footer title="Редактировать заказ">
            <div v-if="edit_order" class="d-block">
                <div class="row align-items-center">
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Введите Имя" label="Имя:" >
                            <b-form-input v-model.trim="edit_order.name" :class="{'is-invalid': $v.edit_order.name.$invalid }" required></b-form-input>
                            <div v-if="!$v.edit_order.name.required" class="invalid-feedback">Обязательное поле</div>
                        </b-form-group>
                    </div>
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Введите Фамилию" label="Фамилия:">
                            <b-form-input v-model.trim="edit_order.surname" required></b-form-input>

                        </b-form-group>
                    </div>
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Введите email" label="Email:">
                            <b-form-input v-model.trim="edit_order.email" :class="{'is-invalid': $v.edit_order.email.$invalid }" required></b-form-input>
                            <div v-if="!$v.edit_order.email.required" class="invalid-feedback">Обязательное поле</div>
                            <div v-if="!$v.edit_order.email.email" class="invalid-feedback">Введите правильный email </div>
                        </b-form-group>
                    </div>
                </div>

                <div class="row align-items-center">
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Введите Телефон" label="Телефон:">
                            <b-form-input v-model.trim="edit_order.phone" :class="{'is-invalid': $v.edit_order.phone.$invalid }" required></b-form-input>
                            <div v-if="!$v.edit_order.phone.required" class="invalid-feedback">Обязательное поле</div>
                        </b-form-group>
                    </div>
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Введите город" label="Город:">
                            <b-form-input v-model.trim="edit_order.city"  required></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" description="Выберите способ доставки" label="Способ доставки:">
                            <b-form-select v-model="edit_order.delivery_type_id" >
                                <template v-for="(type, i) in delivery_types" >
                                    <option v-bind:key="i" :value="type.id">{{type.name}}</option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </div>
                </div>

                <b-form-group class="mb-3" description="Введите адрес доставки" label="Адрес:">
                    <b-form-textarea v-model.trim="edit_order.address" :class="{'is-invalid': $v.edit_order.address.$invalid}"></b-form-textarea>
                    <div v-if="!$v.edit_order.phone.address" class="invalid-feedback">Обязательное поле</div>
                </b-form-group>

                <div class="row align-items-center">
                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" label="Вид платежа:">
                            <b-form-select v-model="edit_order.payment.type" >
                                <option value="Картой онлайн">Картой онлайн</option>
                                <option value="Наличными">Наличными</option>
                                <option value="Банковский перевод">Банковский перевод</option>
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" label="Статус оплаты:">
                            <b-form-select v-model="edit_order.payment.status" >
                                <option value="Ожидает">Ожидает</option>
                                <option value="Выполнен">Выполнен</option>
                                <option value="Ошибка">Ошибка</option>
                            </b-form-select>
                        </b-form-group>
                    </div>

                    <div class="col-md-4 my-2 my-md-0">
                        <b-form-group class="mb-2" label="Всего к оплате:">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <button @click="getSum" v-b-tooltip.hover title="Пересчитать итоговую сумму заказа на основе всех товаров и их количества" ref="get_product_url" class="btn btn-primary" type="button">Пересчитать</button>
                                </div>
                                <b-form-input v-model.number="edit_order.payment.sum" :class="{'is-invalid': errors['payment.sum']}" required></b-form-input>
                                <div v-if="errors['payment.sum']" class="invalid-feedback">{{errors['payment.sum'][0]}}</div>
                            </div>
                        </b-form-group>
                    </div>
                </div>

                <div class="row justify-content-center py-8 px-8 py-md-10 px-md-0">
                    <div class="col-md-12">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th class="pl-0 font-weight-bold text-muted  text-uppercase">Товары</th>
                                    <th class="font-weight-bold text-muted text-uppercase">Доставка</th>
                                    <th class="font-weight-bold text-muted text-uppercase">Артикул</th>
                                    <th class="font-weight-bold text-muted text-uppercase">Кол-во</th>
                                    <th class="font-weight-bold text-muted text-uppercase">Цена шт.</th>
                                    <th class="pr-0 font-weight-bold text-muted text-uppercase">Сумма</th>
                                    <th class="pr-0 font-weight-bold text-muted text-uppercase">Удалить</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(item, i) in edit_order.ordered_items">
                                    <tr  v-bind:key="i" class="font-weight-boldest">
                                        <td style="max-width: 200px" class="border-0 pl-0 pt-7 ">


                                            <div class="d-flex align-items-center">
                                                <div class="symbol symbol-40 flex-shrink-0 mr-4 bg-light">
                                                    <div class="symbol-label" :style="{ backgroundImage: 'url(' + $urlBackEnd(item.image) + ')' }"></div>
                                                </div>
                                                <span class="text-dark flex-root font-weight-bold"><router-link :to="{ name: 'FormProduct', params: {action: 'edit', id: item.product_id}}">{{item.title}}</router-link></span>

                                            </div>

                                            <div class="mt-2">
                                                <span class="font-weight-boldest">Еденица измерения: </span>
                                                {{item.unit_of_measure}}
                                            </div>

                                            <div class="mt-2">
                                                <span class="font-weight-boldest">Вес: </span>
                                                {{item.weight}}
                                            </div>

                                            <div class="mt-2">
                                                <span class="font-weight-boldest">Объём: </span>
                                                {{item.volume}}
                                            </div>




                                            <div v-if="item.properties && item.properties.length > 0">
                                                <div class="mt-2" v-for="property in item.properties">
                                                    <span class="font-weight-boldest">{{property.name}}:</span> {{ property.value.name}} <br>
                                                </div>
                                            </div>

                                           </td>

                                        <td class=" pt-7 align-middle">
                                            <span class="opacity-70">{{item.sku}}</span>
                                        </td>


                                        <td style="min-width: 100px" class="text-right pt-7 align-middle">
                                            <div class="my-2 my-md-0">

                                                <b-form-select v-model="item.city" class="mb-2" >
                                                    <option :value="null"> -- Город --</option>
                                                    <template v-for="(city, i) in item.cities" >
                                                        <option v-bind:key="i" :value="city">{{city.name}}</option>
                                                    </template>
                                                </b-form-select>

                                                <b-form-select v-if="item.city" v-model="item.method" >
                                                    <option :value="null"> -- Метод --</option>
                                                    <template v-for="(method, i) in item.city.methods" >
                                                        <option v-bind:key="i" :value="method">{{method.name}}</option>
                                                    </template>
                                                </b-form-select>
                                            </div>
                                        </td>

                                        <td style="max-width: 100px" class="text-right pt-7 align-middle">
                                            <div class="my-2 my-md-0">

                                                <b-form-group class="mb-2">
                                                    <div class="input-group">
                                                        <b-form-input
                                                                v-model.number="item.qty"
                                                        ></b-form-input>
                                                    </div>
                                                </b-form-group>

                                            </div>
                                        </td>

                                        <td style="max-width: 100px" class=" pt-7 align-middle">
                                            <div class="my-2 my-md-0">

                                                <b-form-group class="mb-2">
                                                    <div class="input-group">
                                                        <b-form-input
                                                                v-model.number="item.price"
                                                        ></b-form-input>
                                                    </div>
                                                </b-form-group>
                                            </div>
                                        </td>

                                        <td class="text-primary pr-0 pt-7 align-middle">{{numberWithSpaces(total(item.price, item.qty))}} <i class="text-primary icon-nm fas fa-ruble-sign"></i></td>
                                        <td class="pr-0 pt-7 align-middle text-right">
                                            <b-link @click="deleteItemShow(item)" v-b-tooltip.hover title="Удалить товар из заказа" class="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"><i class="fas fa-trash-alt"></i></b-link>
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>

                            <div class="d-flex justify-content-between border-top pt-10">
                                <div class="mr-2">
                                </div>
                                <div><b-button @click="addProductToOrder" variant="primary" class="px-9 py-4">Добавить товар</b-button></div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>


            <b-button ref="add_option" class="mt-3" variant="outline-primary" block @click="saveOrder" >Сохранить</b-button>
        </b-modal>



        <b-modal ref="add-product-to-order" size="xl" centered hide-footer title="Добавить товар" ok-only>



            <label for="search_products">Поиск по имени или артикулу</label>
            <div class="input-icon">
                <input v-model.trim="products_filter.search" type="text" class="form-control form-control-solid" placeholder="Поиск.." id="search_products" />
                <span><i class="flaticon2-search-1 text-muted"></i></span>
            </div>

            <b-button @click="getSearchProducts" class="mt-3" variant="primary" block >Поиск</b-button>


            <div v-if="add_products.length === 0" class="text-center my-10">
                Товары не найдены!
            </div>

            <div v-if="load_products" class="text-center mb-10">
                <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </div>


            <!--begin::Table-->
            <div v-else class="table-responsive mt-3">
                <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_4">
                    <thead>
                    <tr class="text-left">
                        <th class="pl-0">Название</th>
                        <th>Цена</th>
                        <th>Категория</th>
                        <th class="pr-0 text-right">Действия</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(product, i) in add_products">
                        <tr v-bind:key="i">
                            <td class="pl-0">
                                <div class="d-flex align-items-center">
                                    <div class="symbol symbol-50 flex-shrink-0 mr-4">
                                        <div class="symbol-label"
                                             :style="{ backgroundImage: 'url(' + $urlBackEnd(product.images[0].thumbnail) + ')' }"></div>
                                    </div>

                                    <div>
                                        <router-link :to="{ name: 'FormProduct', params: {action: 'edit', id: product.id}}" class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">{{product.title}}</router-link>
                                        <span class="text-muted font-weight-bold d-block">Артикул: {{product.sku}}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span v-if="product.variants && product.variants.length > 0">
                                    <a href="javascript:void(0)" @click="addItem(product.id)"><strong>Варианты</strong></a>
                                </span>
                                <span v-else>
                                    <div v-if="product.sale">
                                            <small><del>{{numberWithSpaces(product.price)}} <i class="fas fa-ruble-sign"></i></del></small>
                                            <br><strong>{{numberWithSpaces(product.discount)}} <i class="fas fa-ruble-sign"></i></strong>
                                        </div>
                                        <div v-else>
                                            <strong>{{numberWithSpaces(product.price)}} <i class="fas fa-ruble-sign"></i></strong>
                                        </div>
                                </span>
                            </td>
                            <td>
                                <span v-if="product.categories.length > 0" class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                    <template v-for="category in product.categories">
                                        {{category.name}} <br>
                                    </template>
                                </span>
                                <span v-else class="text-dark-75 font-weight-bolder d-block font-size-lg">
                                    Нет категории
                                </span>
                            </td>
                            <td class="pr-0 text-right">
                                <b-button @click="addItem(product.id)" ref="add_items-btn"  class="btn btn-light-success font-weight-bolder font-size-sm"
                                :class="[spinner.on && spinner.item === product.id ? 'spinner spinner-light spinner-right' : '']"
                                >

                                    <template v-if="product.variants && product.variants.length > 0">
                                        Выбрать
                                    </template>

                                    <template v-else>
                                        Добавить
                                    </template>

                                </b-button>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>

            <a href="#" @click="resetFilter">Сбросьте фильтры</a>

        </b-modal>


        <b-modal modal-class="modal-dark" ref="select-variant-to-product" centered hide-footer title="Выберите вариант товара">
            <div class="d-block">

                <div v-if="addProduct.variants.length > 0" class="content px-0 mb-0">

                    <table class="table">
                        <thead>
                        <tr class="text-left">
                            <th class="pl-0">Свойства</th>
                            <th>Цена</th>
                            <th class="pr-0 text-right">Выбрать</th>
                        </tr>
                        </thead>
                        <tr v-for="variant in addProduct.variants">
                            <td class="pl-0">
                                <div class="d-flex align-items-center">
                                    <div class="symbol symbol-50 flex-shrink-0 mr-4">
                                        <div v-if="variant.images.length > 0" class="symbol-label"
                                             :style="{ backgroundImage: 'url(' + $urlBackEnd(variant.images[0].thumbnail) + ')' }">
                                        </div>
                                    </div>

                                    <div>
                                        <span v-if="variant.sku"><strong>{{variant.sku}}</strong></span>
                                        <small v-if="addProduct.type === 'in_stock'"><br>Кол-во: {{variant.stock}}</small>
                                        <div v-if="variant.attributes.length > 0">
                                            <template  v-for="attribute in variant.attributes">
                                                <small>{{attribute.name}}: {{ attribute.value.name}} </small><br>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td>
                                <span>
                                    <div v-if="variant.sale">
                                        <small><del>{{numberWithSpaces(variant.price)}} <i class="fas fa-ruble-sign"></i></del></small>
                                        <br><strong>{{numberWithSpaces(variant.discount)}} <i class="fas fa-ruble-sign"></i></strong>
                                    </div>
                                    <div v-else>
                                        <strong>{{numberWithSpaces(variant.price)}} <i class="fas fa-ruble-sign"></i></strong>
                                    </div>
                                </span>
                            </td>
                            <td class="pr-0 text-right">
                                <b-button @click="createItem(addProduct, variant)" ref="add_items-btn"  class="btn btn-light-success font-weight-bolder font-size-sm">Выбрать</b-button>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </b-modal>


        <b-modal ref="delete-item-order" centered hide-footer hide-header title="Подтвердите действие" ok-only>
            <div class="d-block text-center">
                <h3>Удалить товар из заказа?</h3>
                <p>Также обновится количество товара в запасе</p>
            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideDeleteItem">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="outline-danger" block @click="deleteItem">Удалить</b-button>
                </b-col>
            </b-row>
        </b-modal>

        <b-modal ref="delete-modal" centered hide-footer hide-header title="Подтвердите действие">
            <div class="d-block text-center">
                <h3>Удалить заказ: #{{order.id}}?</h3>
            </div>
            <b-row>
                <b-col>
                    <b-button class="mt-3" variant="outline-primary" block @click="hideDeleteOrder">Отмена</b-button>
                </b-col>
                <b-col>
                    <b-button class="mt-3" variant="outline-danger" block @click="deleteOrder">Удалить</b-button>
                </b-col>
            </b-row>
        </b-modal>


    </div>
</template>

<script>
    import moment from "moment";
    require('moment/locale/ru');
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {
        DELETE_ORDER,
        GET_ORDER,
        UPDATE_ORDER,
        UPDATE_ORDER_STATUS
    } from "../../../core/services/store/orders.module";
    import {SET_ALERT} from "../../../core/services/store/alert.module";

    import { required, email } from 'vuelidate/lib/validators'
    import {GET_PRODUCT, GET_PRODUCTS} from "../../../core/services/store/products.module";
    export default {
        name: "OrderDetails",

        validations: {
            edit_order: {
                name: {required},
                email: {required, email},
                phone: {required},
                address: {required},
            }
        },

        mounted(){
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Все заказы", route: "/orders" },
                { title: "Детали заказа" }
            ]);
            this.$store.dispatch(GET_ORDER, this.$route.params.id);
        },


        computed: {
            ...mapGetters({
                order: 'gettersOrder',
                load: 'getOrderLoad',
                errors: 'errorsOrders',
                statuses: 'gettersStatuses',
                delivery_types: 'gettersDeliveryTypes',
                add_products: 'gettersProducts',
                load_products: 'getProductLoad',

            })

        },

        data(){
            return{
                save_status: {},
                moment:moment,

                addProduct: {
                    variants: []
                },

                spinner: {
                    on: false,
                    item: null
                },

                products_filter: {
                    to: '20',
                    price_from: '',
                    price_to: '',
                    new: false,
                    sale: false,
                    search: '',
                    category: null,
                    sub_category: null,
                    status: null,
                    stock_from: '',
                    stock_to: '',
                    sort: 'data-new',
                    trashed: false,
                    attributes: []

                },

                delete_item: {
                    title: null,
                    product_id: null,
                    variant_id: null,
                },
                edit_order: {
                    id:'',
                    payment: {
                        type: '',
                        status: '',
                        sum: '',
                    }
                }
            }
        },

        methods:{
            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            numberWithSpaces(x){
                if (x){
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                } else {
                    return 0;
                }
            },

            total(price, qty){
                let sum = price * qty;
                return +sum.toFixed(2)
            },

            editOrder(){
                this.edit_order = this.lodash.cloneDeep(this.order);
                this.$refs['edit-order'].show()
            },

            saveOrder(){
                this.$store.dispatch(UPDATE_ORDER, {id: this.order.id, order: this.edit_order})
                    .then(() => {
                        this.$store.dispatch(GET_ORDER, this.$route.params.id);
                        this.showAlert('Заказ успешно сохранен', 'success', 'toast');
                        this.$refs['edit-order'].hide()
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
            },

            updateStatus(){
                const submitStatus = this.$refs["update-status"];
                submitStatus.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(UPDATE_ORDER_STATUS, {id: this.order.id, status: this.order.order_status_id})
                    .then(() => {
                        this.showAlert('Статус успешно сохранен', 'success', 'toast');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                    })
                    .finally(()=> {
                        submitStatus.classList.remove("spinner", "spinner-light", "spinner-right")
                    })
            },

            getSum(){
                var sum = 0;
                this.edit_order.ordered_items.forEach(function (item) {
                    sum = sum + (item.price * item.qty);
                });
                this.edit_order.payment.sum = sum
            },

            deleteItemShow(item){
                this.delete_item = {
                    title: item.title,
                    product_id: item.product_id,
                    variant_id: item.variant_id
                };
                this.$refs['delete-item-order'].show()
            },

            deleteItem(){
                const indexItem = this.order.ordered_items.findIndex(
                    obj => obj.product_id === this.delete_item.product_id && obj.variant_id === this.delete_item.variant_id
                );
                this.edit_order.ordered_items.splice(indexItem , 1);
                this.hideDeleteItem()
            },

            async addItem(id){
                this.spinner.on = true;
                this.spinner.item = id;
                try {
                    const data = await this.$store.dispatch(GET_PRODUCT, id);
                    if (data.product){
                        if (data.product.variants.length > 0){
                            this.addProduct = data.product;
                            this.$refs['add-product-to-order'].hide();
                            this.$refs['select-variant-to-product'].show();
                        } else {
                            this.createItem(data.product)
                        }
                    }

                } catch (e) {
                    console.log(e)
                    this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                } finally {
                    this.spinner.on = false;
                    this.spinner.item = null;
                }
            },

            createItem(data, variant){
                let image;
                let price;
                let properties = [];

                if (variant){
                    if (variant.images.length > 0){
                        image = variant.images[0].thumbnail
                    } else {
                        image = data.images.length > 0 ? data.images[0].thumbnail : null;
                    }

                    if (variant.sale){
                        price = variant.discount ? variant.discount : data.discount;
                    } else {
                        price = variant.price ? variant.price : data.price;
                    }

                    if (variant.attributes && variant.attributes.length > 0){
                        variant.attributes.forEach((attribute) => {
                            const att = {
                                name: attribute.name,
                                value: attribute.value.name,
                            };
                            properties.push(att)
                        })
                    }

                    this.$refs['select-variant-to-product'].hide()

                } else {
                    image = data.images.length > 0 ? data.images[0].thumbnail : null;
                    if (data.sale){
                        price = data.discount;
                    } else {
                        price = data.price;
                    }
                }

                let item = {
                    image: image,
                    title: data.title,
                    unit_of_measure: data.unit_of_measure,
                    weight: data.weight,
                    volume: data.volume,
                    sku: variant ? variant.sku : data.sku,
                    product_id: data.id,
                    variant_id: variant ? variant.id : null,
                    qty: 1,
                    price: price,
                    sale: variant ? variant.sale : data.sale,
                    properties: properties,
                    cities: data.cities.length > 0 ? data.cities : [],
                    city: data.cities.length > 0 ? data.cities[0] : null,
                    method: data.cities.length > 0 && data.cities[0].methods.length > 0 ? data.cities[0].methods[0] : null
                };

                const checkItem = this.edit_order.ordered_items.find(obj => obj.product_id === item.product_id && obj.variant_id === item.variant_id);

                if (checkItem){
                    checkItem.qty = checkItem.qty + item.qty;
                    checkItem.price = checkItem.price + item.price;
                    const indexToSave = this.edit_order.ordered_items.findIndex(obj => obj.product_id === item.product_id && obj.variant_id === item.variant_id);
                    this.edit_order.ordered_items.splice(indexToSave , 1, checkItem);
                } else {
                    this.edit_order.ordered_items.push(item);
                }


                this.$refs['add-product-to-order'].hide();

                this.addProduct = {
                    variants: []
                };

                this.showAlert('Товар успешно добавлен в заказ', 'success', 'toast');
            },

            hideDeleteItem(){
                this.$refs['delete-item-order'].hide()
            },



            addProductToOrder(){
                this.$store.dispatch(GET_PRODUCTS, {'filter': this.products_filter});
                this.$refs['add-product-to-order'].show()
            },

            getSearchProducts(){
                this.$store.dispatch(GET_PRODUCTS, {'filter': this.products_filter})
            },

            resetFilter(){
                const reset_filter = {
                    to: '20',
                    price_from: '',
                    price_to: '',
                    new: false,
                    sale: false,
                    search: '',
                    category: null,
                    sub_category: null,
                    status: null,
                    stock_from: '',
                    stock_to: '',
                    sort: 'data-new',
                    trashed: false,
                    attributes: []
                };

                this.products_filter = reset_filter;
                this.getSearchProducts()
            },

            updatePrice(item){
                if (item.product.variants.length > 0){
                    item.price = item.product.variants.find(obj => obj.id === item.variants_id).price;
                } else {
                    item.price = item.product.price
                }
            },


            showDeleteOrder(){
                this.$refs['delete-modal'].show()
            },

            hideDeleteOrder(){
                this.$refs['delete-modal'].hide()
            },

            deleteOrder(){
                this.$store.dispatch(DELETE_ORDER, this.order.id)
                    .then(() => {
                        this.showAlert('Заказ успешно удален (перемещен в архив)', 'success');
                        this.$router.push({ name: "Orders" })
                    })
                    .catch(() => {
                        this.showAlert('Ошибка удаления', 'danger', 'toast');
                    })
                    .finally(() => {
                        this.hideDeleteOrder()
                    })
            },


        },


    }
</script>

<style scoped>

</style>